import { useMutation } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import { withErrorHandling } from '@/modules/common/utils/error-utils.tsx';
import {
  GenerateCertificatesForRegisterRequest,
  GenerateCertificatesForRegisterResponse,
} from 'api';

export const useGenerateRegisterCertificatesMutation = () => {
  return useMutation({
    mutationFn: async (payload: GenerateCertificatesForRegisterRequest) => {
      const response = await withErrorHandling<GenerateCertificatesForRegisterResponse>(
        api.v1.generateCertificatesForRegisterV1SrCertificatesGenerateCertificatesForRegisterPost(
          payload,
        ),
        {
          loading: 'Start of certificates generation...',
          success: 'Generation is started',
        },
      );

      return response.data;
    },
  });
};
